const AlertPop = ({ handleOpenModal }) => {
    return (
        <div className="modal_body">
            <div className="attached_courses-alert">
                <h2>Alert!</h2>
                <p className="text_center mt_3">You are trying to delete a event that has 1 or more users attached to it.</p>
                <input onClick={() => handleOpenModal()} type="reset" className="btn btn_gray d_block mx_auto" value="ok" />
            </div>
        </div>
    )
};

export default AlertPop;